import { useState } from 'react';

import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const COMPENSATION_CYCLES = [
  {
    value: 'ALL_CYCLES',
    label: 'All Cycles',
  },
  {
    value: 'Q1_2025',
    label: 'Q1 2025',
  },
  {
    value: 'Q2_2025',
    label: 'Q2 2025',
  },
  {
    value: 'Q3_2025',
    label: 'Q3 2025',
  },
];

export const CompensationCycleDropdown = () => {
  const [compensationCycle, setCompensationCycle] = useState<string>('ALL_CYCLES');

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip>
          <TextBodyMedium bold color="text.g2">
            Compensation cycle :
          </TextBodyMedium>
          <TextBodyMedium bold color="text.g1">
            {COMPENSATION_CYCLES.find((cycle) => cycle.value === compensationCycle)?.label}
          </TextBodyMedium>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent>
        <DropdownRadioGroup value={compensationCycle}>
          {COMPENSATION_CYCLES.map((cycle) => (
            <DropdownRadioItem key={cycle.value} value={cycle.value} onClick={() => setCompensationCycle(cycle.value)}>
              {cycle.label}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};
